import { unflatten } from 'flat';
import Validator from '../../../../../../components/forms/validate';
import { LEARN_MORE_URL_MAX_LENGTH, lowerCaseUrlScheme, normalizeLearnMoreUrl } from '../../../../../../helpers/learnMoreUrl';

const RULES = {
	partnerPreviewLearnMoreUrl: ['url', `max:${LEARN_MORE_URL_MAX_LENGTH}`]
};

const CUSTOM_MESSAGES = {
	'url.partnerPreviewLearnMoreUrl': 'Learn More URL must start with http:// or https://',
	'max.partnerPreviewLearnMoreUrl': `Learn More URL must be at most ${LEARN_MORE_URL_MAX_LENGTH} characters.`
};

class ValidationService {
	// Empty is valid on purpose: the validator only applies `url` to a non-empty value, and an
	// empty Learn More URL is how an admin turns the banner button off. The value is trimmed
	// first because that is what gets sent; a pasted leading space must not fail the rule.
	static validate = (values) => {
		const validator = new Validator({
			partnerPreviewLearnMoreUrl: lowerCaseUrlScheme(normalizeLearnMoreUrl(values.partnerPreviewLearnMoreUrl))
		}, RULES, CUSTOM_MESSAGES);

		return (validator.fails() ? unflatten(validator.errors.all()) : {});
	};
}

export default ValidationService;
